export type ScheduleFiltersState = {
  sort: string
  sortByTypeUnit: string
  byOfferStatus: string
  byViewingStatus: string

  byOfferGroups: string
  byViewingGroups: string
  byAddsGroups: string

  unitID: number
}

export const DEFAULT_SCHEDULE_FILTERS: ScheduleFiltersState = {
  sort: 'all',
  sortByTypeUnit: 'all',
  byOfferStatus: 'all',
  byViewingStatus: 'all',
  byOfferGroups: 'all',
  byViewingGroups: 'all',
  byAddsGroups: 'all',
  unitID: 0
}
